<template>
  
<div>
     <HeaderBreadcrumbs
  :items="[
    { label: 'Books', to: '/ebooks' },
    { label: `Bulk Update File ${this.slug}`, to: `/items/bulk/upload/${this.slug}` },
    { label: 'Log Activity' }
  ]"
  title="Log Activity"
/>
  <div class="border rounded-xl overflow-hidden mb-5">
<Table :headers="headers" :data="items" :withNumberCol="false"
      :row-key="['created_at', 'total_items', 'created_by']"
     :current-page="currentPage" :isLoading="isLoading"
      :per-page="15">
        <template #header-date="{ column }">
            <div class="flex justify-between items-center gap-1 px-3">
              {{ column.label }}
              <button @click="sortBy(column.key)" class="text-xs text-gray-500">
                <span href="#"><svg class="w-3 h-3 ms-1.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                    fill="currentColor" viewBox="0 0 24 24">
                    <path
                      d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
                  </svg>
                </span>
              </button>
            </div>
          </template>
            <template class='text-right' #actions="{ row }">
              <div class='tooltip-wrapper'>
                <div class="w-20 cursor-pointer text-right flex justify-end relative -top-1 right-2" :class="{ 'opacity-50 pointer-events-none': row.status === 0 }" @click="goToDetail(row)">
                  <svg class="w-5 h-5 text-gray-500 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
                    <path fill-rule="evenodd" d="M4.998 7.78C6.729 6.345 9.198 5 12 5c2.802 0 5.27 1.345 7.002 2.78a12.713 12.713 0 0 1 2.096 2.183c.253.344.465.682.618.997.14.286.284.658.284 1.04s-.145.754-.284 1.04a6.6 6.6 0 0 1-.618.997 12.712 12.712 0 0 1-2.096 2.183C17.271 17.655 14.802 19 12 19c-2.802 0-5.27-1.345-7.002-2.78a12.712 12.712 0 0 1-2.096-2.183 6.6 6.6 0 0 1-.618-.997C2.144 12.754 2 12.382 2 12s.145-.754.284-1.04c.153-.315.365-.653.618-.997A12.714 12.714 0 0 1 4.998 7.78ZM12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" clip-rule="evenodd"/>
                  </svg>
                </div>
                <span v-if="row.status === 0" class="tooltip-box">
                  Your request is being processed.
                </span>
              </div>
            </template>
           <template #created_at="{ value }">
            <p class="px-3">{{ formatDate(value) }}</p>
            </template>
             <template #created_by="{ value }">
              <p class="text-left lowercase">{{ value }}</p>
            </template>
            <template #total_items="{ value }">
              <p class="text-center">{{ value }}</p>
            </template>
            
    </Table>
     <div v-if="!isLoading && items.length  " class="flex bg-white justify-between pl-3 pr-3 pt-4 mb-0 border-t border-gray-100 mt-0">
          <div class="font-semibold">
            <span class="text-gray-500 font-normal">Showing </span> {{ currentPage }}-{{  items.length }} <span
              class="text-gray-500 font-normal">of</span> {{ parseInt(totalRows) }}
          </div>
          <div class="mb-2">
            <t-pagination :total-items="Number(totalRows)" :per-page="15" v-model="currentPage"
              @change="onClickPage" />
          </div>
        </div>
  </div>
  
</div>
</template>

<script>
import HeaderBreadcrumbs from '@/components/HeaderBreadcrumbs';
import { mapActions, mapState } from 'vuex';
import moment from 'moment'
import Table from '@/components/form/table.vue';

export default {
    components: {
    HeaderBreadcrumbs,
    Table
  },
   data() {
    return {
      slug: '',
      currentPage:1,
      sortOrder: 'created_at_desc',
     
       headers: [
          { },
        { label: 'Import Date', key: 'created_at', sortable: true, slotHeader: 'header-date',  style: 'width: 700px; padding-left: 16px; padding-right: 16px;'},
        { label: 'Total Books', key: '' },
        { label: 'Processed By', key: '' }
      ],
    };
  },
   mounted() {
    this.slug = this.$route.params.slug
    this.fetchBulkItem()
    },
    
   
  computed: {
  ...mapState({
    items: state => state.bulkUpload.items,
    totalRows: (state) => state.bulkUpload.totalRows,
     isLoading: (state) => state.bulkUpload.isLoading,
  })
},
  methods:{
     ...mapActions('bulkUpload', ['getBulkItem']),
     fetchBulkItem() {
        this.getBulkItem({
          item_type: ['book'],
          page: this.currentPage,
          limit: 15,
          sort: this.sortOrder
        })
},
onClickPage(page)
{
this.currentPage = page;
this.fetchBulkItem()
},
 sortBy() {
  this.sortOrder = this.sortOrder === 'created_at_asc' ? 'created_at_desc' : 'created_at_asc'

  this.getBulkItem({
    item_type: 'book',
    page: this.currentPage,
    limit: 15,
    sort: this.sortOrder,
   // order_by: sortByPeriode
  })
},
 goToDetail(row) {
  const date = row.created_at
  this.$router.push({
    path: `/items/bulk/log_activity/${date}`,
    query: { id: row.id }
  })
  },
formatDate(date) {
  if (!date) return '-'
  return moment(date).format('DD MMMM YYYY, HH:mm')
}
  },
 
}
</script>
<style scoped>
.tooltip-wrapper {
  position: relative;
  display: inline-block;
}

.tooltip-box {
  position: absolute;
  top: 30%;
  right: 40px;
  transform: translateY(-50%);
  width: max-content;
  max-width: 200px;
  padding: 8px 6px;
  font-size: 12px;
  color: white;
  background: #374151; 
  border-radius: 6px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.2s ease, visibility 0.2s ease;
  pointer-events: none;
  z-index: 1000;
}

.tooltip-wrapper:hover .tooltip-box {
  opacity: 1;
  visibility: visible;
}

/* Triangle pointer */
.tooltip-box::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 100%;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-top: 6px solid transparent;
  border-bottom: 6px solid transparent;
  border-left: 6px solid #374151;
}
</style>